export const CHECKOUT_URL = 'https://rutaclinica.impultienda.ar/checkout/hipertension'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/9fe818YQw7dtJiGTdJesnD/Menopausia-3.png'

export const metrics = [
  { value: '+300', label: 'Decisiones clínicas simplificadas' },
  { value: '+2.000', label: 'Médicos que ya confían en la Ruta' },
  { value: '1.800+', label: 'Horas al año que dejas de perder revisando guías' },
  { value: '99%', label: 'Recomendarían Ruta Hipertensión a un colega' },
]

export const beforeItems = [
  'Revisar varias guías para responder una sola duda',
  'Dudar entre monoterapia o combinación',
  'Sentir que cada guía recomienda algo distinto',
  'Improvisar cuando el paciente no alcanza las metas',
  'Temer cometer errores en pacientes complejos',
  'Invertir más tiempo buscando respuestas que atendiendo pacientes',
]

export const afterItems = [
  'Seguir una ruta clara y decidir en minutos',
  'Elegir el tratamiento con un algoritmo paso a paso',
  'Aplicar un criterio clínico único y basado en evidencia',
  'Saber exactamente cuándo ajustar, intensificar o derivar',
  'Actuar con seguridad incluso en diabetes, ERC o embarazo',
  'Tener las respuestas listas para usar durante la consulta',
]

export const painPoints = [
  'Tienes un paciente frente a ti y dudas si intensificar el tratamiento o cambiar completamente la estrategia.',
  'Cada consulta termina con la sensación de que deberías revisar otra guía antes de sentirte seguro.',
  'Los pacientes con diabetes, enfermedad renal o múltiples comorbilidades te obligan a detener la consulta para confirmar la mejor conducta.',
  'No siempre tienes claro cuándo puedes resolver el caso en atención primaria y cuándo es momento de derivar.',
  'Tus controles son poco estructurados y cada seguimiento parece empezar desde cero.',
  'En escenarios urgentes, sabes que una decisión equivocada puede cambiar el pronóstico del paciente.',
]

export const contentBlocks = [
  {
    emoji: '📘',
    title: '6 Tomos Clínicos',
    text: 'Recorre todo el manejo de la hipertensión, desde la sospecha diagnóstica hasta el seguimiento a largo plazo.',
  },
  {
    emoji: '🩺',
    title: 'Más de 300 Protocolos',
    text: 'Resuelve las situaciones más frecuentes con algoritmos visuales, tablas de decisión y rutas listas para aplicar.',
  },
  {
    emoji: '📊',
    title: 'Algoritmos de Decisión',
    text: 'Descubre cuándo iniciar tratamiento, cuándo intensificarlo y cuándo cambiar la estrategia con criterios claros.',
  },
  {
    emoji: '⚡',
    title: 'Pacientes Complejos',
    text: 'Diabetes, enfermedad renal, adulto mayor, embarazo e hipertensión resistente en rutas específicas.',
  },
  {
    emoji: '📋',
    title: 'Tablas Clínicas',
    text: 'Consulta dosis, equivalencias y esquemas terapéuticos sin perder tiempo buscando en distintas fuentes.',
  },
  {
    emoji: '🎯',
    title: 'Sistema de Seguimiento',
    text: 'Un proceso estructurado para documentar, controlar y ajustar el tratamiento en cada visita.',
  },
]

export const deliveryItems = [
  'Los 6 Tomos Clínicos',
  'Más de 300 protocolos',
  'Algoritmos de decisión rápida',
  'Rutas para pacientes complejos',
  'Sistema de seguimiento',
  'Los 5 bonos exclusivos',
]

export type Bonus = {
  code: string
  title: string
  text: string
  price: string
  image?: string
}

export const bonuses: Bonus[] = [
  {
    code: 'B1',
    title: 'El Atlas de la Combinación',
    text: 'Elige la combinación antihipertensiva correcta en segundos con un algoritmo visual que evita errores frecuentes de prescripción.',
    price: '$27 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/qG4Acpm1onXXHBvMJbJZM1/BONO_1_HIPERTENSION.png',
  },
  {
    code: 'B2',
    title: 'Recetario Clínico HTA',
    text: '50 esquemas terapéuticos listos para aplicar según el perfil de cada paciente, sin empezar desde cero en cada consulta.',
    price: '$37 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/ogpHLGWXtHqpruPuDg1NwJ/BONO_2_HIPERTENSION.png',
  },
  {
    code: 'B3',
    title: 'Checklist Maestro de HTA Secundaria',
    text: 'Detecta oportunamente las principales causas secundarias antes de intensificar el tratamiento innecesariamente.',
    price: '$27 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/nRk465K6GGJ9mV2vkhW31r/BONO_3_HIPERTENSION.png',
  },
  {
    code: 'B4',
    title: 'Kit Educativo Pro-Paciente',
    text: 'Material profesional que mejora la adherencia y reduce el tiempo dedicado a repetir las mismas recomendaciones.',
    price: '$20 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/iTxSp2shdMz7ToDAtV4vJy/BONO_4_HIPERTENSION.png',
  },
  {
    code: 'B5',
    title: 'Maestro del MAPA y AMPA',
    text: 'Interpreta correctamente cualquier registro domiciliario o ambulatorio con criterios claros y casos prácticos.',
    price: '$37 USD',
    image:
      'https://cdn.magicpatterns.com/uploads/k893sLDTtwEebsJWA6xihN/BONO_5_HIPERTENSION.png',
  },
]

export const testimonials = [
  {
    name: 'Dr. Andrés Villalba',
    role: 'Medicina Interna · Bogotá, Colombia',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e1918cd3-05b8-411e-8492-848d55b32a5a.jpg',
    quote:
      'Dejé de abrir tres guías por consulta. Ahora sigo la ruta, decido en minutos y el paciente lo nota en la seguridad con la que le explico.',
  },
  {
    name: 'Dra. Marcela Ruiz',
    role: 'Medicina Familiar · Ciudad de México',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/06dc668d-88a4-4fbd-a9f1-e0e0c69aced8.jpg',
    quote:
      'El algoritmo de combinación me resolvió la duda que más me frenaba. Prescribo con criterio y sin miedo a equivocarme.',
  },
  {
    name: 'Dr. Julián Espinoza',
    role: 'Residente MI · Lima, Perú',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/3f1dc0d1-fb8c-4288-bb1e-897a5287f599.jpg',
    quote:
      'En guardia no tengo tiempo de leer 200 páginas. Abro la ruta, ubico el escenario y actúo. Vale muchísimo más de lo que cuesta.',
  },
  {
    name: 'Dra. Carmen Ortiz',
    role: 'Cardiología · Santiago, Chile',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7cd41b9a-9afa-4b73-814f-4286e62c4fb4.jpg',
    quote:
      'Lo que más valoro son las rutas para pacientes complejos. Diabetes, ERC y embarazo resueltos con un criterio único y actualizado.',
  },
]

export const faqs = [
  {
    q: '¿Qué diferencia a Ruta Hipertensión de una guía clínica tradicional?',
    a: 'Las guías te muestran toda la evidencia disponible. Ruta Hipertensión organiza esa evidencia en un recorrido práctico para que decidas en minutos durante la consulta, sin revisar cientos de páginas cada vez que surge una duda.',
  },
  {
    q: '¿Recibiré el material inmediatamente?',
    a: 'Sí. Tan pronto se confirme tu pago recibirás un correo con el acceso para descargar todos los tomos y bonos en formato PDF. Podrás consultarlos desde computadora, tablet o teléfono.',
  },
  {
    q: '¿Es útil si ya conozco las guías ESC, ACC/AHA o ISH?',
    a: 'Sí. Ruta Hipertensión no reemplaza las guías: te ayuda a aplicarlas de forma rápida y práctica cuando tienes un paciente frente a ti y el tiempo es limitado.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagas una sola vez y el acceso es permanente. No existen suscripciones ni pagos recurrentes.',
  },
  {
    q: '¿También sirve para residentes?',
    a: 'Definitivamente. Muchos residentes lo usan en consultas, guardias y rotaciones porque resume en pocos minutos decisiones que normalmente obligan a revisar múltiples fuentes.',
  },
]

export const purchaseNotifications = [
  { name: 'Dr. Ricardo M.', place: 'Guadalajara, México' },
  { name: 'Dra. Valeria S.', place: 'Rosario, Argentina' },
  { name: 'Dr. Camilo R.', place: 'Medellín, Colombia' },
  { name: 'Dra. Paula G.', place: 'Montevideo, Uruguay' },
  { name: 'Dr. Esteban L.', place: 'Quito, Ecuador' },
  { name: 'Dra. Andrea T.', place: 'Santiago, Chile' },
  { name: 'Dr. Hugo P.', place: 'Asunción, Paraguay' },
  { name: 'Dra. Lucía F.', place: 'Madrid, España' },
  { name: 'Dr. Óscar B.', place: 'San José, Costa Rica' },
  { name: 'Dra. Mariana C.', place: 'Lima, Perú' },
]
